import React, { useEffect, useReducer, useState } from "react";
import { BrowserRouter, Switch, Route, Link } from "react-router-dom";
import { hot } from "react-hot-loader/root";
import "./styles/Tasks.css";
import "react-datepicker/dist/react-datepicker.css";

import { RiFile2Line, RiAddFill } from "react-icons/ri";
import { Nav, Navbar, Container } from "react-bootstrap";

import Tasks from "./Tasks";
import TaskItem from "./task/TaskItem";
import CreateTask from "./CreateTask";
import Reducer from "./Reducer";
import * as CONST from "../helpers/Constants";
import * as API from "../api";
import { Settings } from "../helpers/Contexts";
import { ErrorBoundary } from "./ErrorBoundary";
import useInterval from "./useInterval";

function App() {
  const [state, dispatch] = useReducer(Reducer, CONST.INIT_STATE);

  async function fetchTasksByCurrentView() {
    if (state.filter.value) {
      const tasks = await API.getFilteredTasks({
        url: state.filter.value,
        page: state.currentPage,
      });
      return dispatch({ type: "set_current_tasks", payload: tasks });
    } else {
      const tasks = await API.getTasksByView({
        view: state.activeView,
        page: state.currentPage,
      });
      return dispatch({ type: "set_current_tasks", payload: tasks });
    }
  }

  async function LoadApp() {
    dispatch({ type: "set_view_loading", payload: true });
    const settings = await API.getSettings();
    dispatch({ type: "set_settings_data", payload: settings });
    const data = await API.getTaskCounts();
    dispatch({ type: "set_task_counts", payload: data.counts });
    fetchTasksByCurrentView();
  }

  useEffect(async () => {
    if (state.settings.loaded == false) {
      dispatch({ type: "set_view_loading", payload: true });
      const settings = await API.getSettings();
      dispatch({ type: "set_settings_data", payload: settings });
      const data = await API.getTaskCounts();
      dispatch({ type: "set_task_counts", payload: data.counts });
      fetchTasksByCurrentView();
    }
  }, []);

  useInterval(
    async () => {
      const prevCounts = state.counts;
      const newCounts = await API.getTaskCounts();
      if (Object.values(prevCounts) == "" + Object.values(newCounts.counts)) {
        return null;
      } else {
        dispatch({ type: "set_task_counts", payload: newCounts.counts });
        console.log("App[useInterval]: refreshing tasks");
        if (!state.searching && !state.filter.value && !state.tags) {
          dispatch({
            type: "set_current_tasks",
            payload: await API.getTasksByView({ view: state.activeView, page: state.currentPage }),
          });
        }
      }
    },

    !state.isCreatingTask && !state.isTaskSelected && !state.filter.value && !state.tags
      ? 20000
      : null
  );

  function Navigation() {
    return (
      <Navbar className="tasks">
        <Nav className="tasks-links">
          <Link to={"/specialists/tasks"} id="tasks" className="link" onClick={() => LoadApp()}>
            <RiFile2Line id="tasks-icon" />
            { (state.settings.me && state.settings.me.specialist_group) || 'My Group' } | Tasks
          </Link>
        </Nav>
      </Navbar>
    );
  }

  return (
    <BrowserRouter>
      <Settings.Provider value={state.settings}>
        <ErrorBoundary>
          <Container className="tasks-dashboard">
            <Navigation />
            <Switch>
              <Route
                path={"/specialists/tasks/item/:id"}
                render={() => (
                  <>
                    <TaskItem dispatch={dispatch} state={state} />
                  </>
                )}
              />
              <Route
                path={"/specialists/tasks/new"}
                render={() => (
                  <>
                    <CreateTask dispatch={dispatch} state={state} />
                  </>
                )}
              />
              <Route
                path={"/specialists/tasks"}
                render={() => (
                  <>
                    <Tasks dispatch={dispatch} state={state} />
                  </>
                )}
              />
            </Switch>
          </Container>
        </ErrorBoundary>
      </Settings.Provider>
    </BrowserRouter>
  );
}

export default hot(App);
